export const showLegendTitle = 'Легенда';
